var searchParams = new URLSearchParams(new URL(window.location.toString()).search);
if (searchParams.has("gclid")) {
    var currentData = localStorage.getItem('gclids');
    if (currentData === null || currentData === undefined) {
        currentData = [];
    } else {
        currentData = JSON.parse(currentData);
    }
    currentData.push({
        date: new Date().toISOString(),
        clickid: searchParams.get("gclid")
    });
 
    localStorage.setItem('gclids', JSON.stringify(currentData));
}